import { RestrictedInputKeyEnum } from "@/types/form";

export const allowedRestrictedInputKeys: string[] = Object.values(
  RestrictedInputKeyEnum,
);
